var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessanger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2217 1.33301C5.21512 1.33301 1.33301 5.0018 1.33301 9.95499C1.33301 12.546 2.3952 14.786 4.12404 16.3326C4.26848 16.4615 4.35737 16.6437 4.36181 16.8392L4.4107 18.4214C4.41426 18.5378 4.44636 18.6516 4.50418 18.7527C4.562 18.8538 4.64377 18.9392 4.7423 19.0013C4.84083 19.0634 4.9531 19.1003 5.06926 19.1089C5.18541 19.1174 5.30189 19.0973 5.40845 19.0503L7.17285 18.2725C7.32173 18.2059 7.49062 18.1948 7.64839 18.237C8.45948 18.4592 9.32168 18.5792 10.2217 18.5792C15.2282 18.5792 19.1103 14.9104 19.1103 9.95722C19.1103 5.00402 15.2282 1.33301 10.2217 1.33301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88402 12.4771L7.49506 8.33504C7.59328 8.17909 7.72277 8.0452 7.87535 7.94182C8.02793 7.83844 8.20028 7.76782 8.38153 7.73441C8.56278 7.70099 8.74899 7.70553 8.9284 7.74771C9.10781 7.78989 9.27653 7.86882 9.4239 7.97949L11.5016 9.53723C11.5944 9.60667 11.7072 9.64402 11.8231 9.64362C11.939 9.64322 12.0515 9.60509 12.1438 9.535L14.9482 7.40617C15.3215 7.12174 15.8104 7.57061 15.5615 7.96838L12.9482 12.1083C12.85 12.2642 12.7205 12.3981 12.568 12.5015C12.4154 12.6049 12.243 12.6755 12.0618 12.7089C11.8805 12.7423 11.6943 12.7378 11.5149 12.6956C11.3355 12.6534 11.1668 12.5745 11.0194 12.4638L8.94169 10.9061C8.84893 10.8366 8.73608 10.7993 8.62021 10.7997C8.50434 10.8001 8.39176 10.8382 8.29948 10.9083L5.49512 13.0371C5.12179 13.3216 4.63292 12.8749 4.88402 12.4771Z",
    fill: "url(#paint0_radial_541_4580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_541_4580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.3107 19.1103) scale(19.555)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessanger);
export default __webpack_public_path__ + "static/media/messanger.2168c826acc487aa33442dd058054c47.svg";
export { ForwardRef as ReactComponent };